module Meevo.Plugins.ClientManualMerge {

    export function manualMergeBirthdayFormat() {
        const MONTHS = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN',
            'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

        return (clientData: any): string => {
            if (!clientData) return;

            const day = clientData.birthDay;
            const month = clientData.birthMonth;
            const year = clientData.birthYear;

            if (day && month && year) {
                return `${pad(day)} ${MONTHS[month - 1]} ${year}`;
            }
            if (day && month) {
                return `${pad(day)} ${MONTHS[month - 1]}`;
            }
            if (month && year) {
                return `${MONTHS[month - 1]} ${year}`;
            }
            if (month) {
                return `${MONTHS[month - 1]}`;
            }
            if (year && (!month && !day)) {
                return `Year: ${year}`;
            }
            return;
        };
    }

    function pad(n: number): string {
        return n < 10 ? '0' + n : n.toString();
    }

    angular.module("meevo.plugins.clientManualMerge")
        .filter('manualMergeBirthdayFormat', manualMergeBirthdayFormat);

}